import Layout from "../components/Layout";

const Contact = () => {

    const methods = [
        {label: 'Email', value: 'joshy.d.simon@gmail.com', url: 'mailto:joshy.d.simon@gmail.com'},
        {label: 'Phone', value: '021 181 0996', url: 'tel:+64211810996'},
        {label: 'LinkedIn', value: 'Joshua Simon', url: 'https://www.linkedin.com/in/joshua-simon-53078768/'}
    ]

    return (
    <Layout>
        <p className="eyebrow">Contact</p>
        <h1 className="page-title">Get in touch</h1>
        <p className="lede">
            I'm looking for part-time work in tech or anything tech-adjacent. If you've got something
            in mind, or just want to chat, I'd love to hear from you.
        </p>
        <div className="contact-list">
            {methods.map(method => (
                <a href = {method.url} className="contact-card" key = {method.label}>
                    <span className="contact-label">{method.label}</span>
                    <span className="contact-value">{method.value}</span>
                </a>
            ))}
        </div>
    </Layout>
    )
}

export default Contact;
